export function IndianPrideFooter() {
  return (
    <div className="flex items-center justify-center gap-2 py-3 text-[11px] text-muted-foreground/70">
      <span>🇮🇳</span>
      <span className="font-display">RupeeVikas — Designed & Engineered in India for the Indian Economy</span>
    </div>
  );
}
